module.exports = __webpack_public_path__ + "assets/img/icon-login-logo.898825a1.png";